interface IconProps {
  color?: string
}

export const DotsHorizontal = ({ color }: IconProps) => {
  return (
    <svg
      aria-hidden="true"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="12" fill={color ?? 'currentColor'} r="2" />
      <circle cx="12" cy="12" fill={color ?? 'currentColor'} r="2" />
      <circle cx="4" cy="12" fill={color ?? 'currentColor'} r="2" />
    </svg>
  )
}
